import {
  AnalyzeCodeComponentsInPackage,
  CodeComponent,
  CodeComponentParentType,
  CodeComponentProperty,
  CodeComponentResolvedType,
  CodeComponentResolvedTypeKind,
  CodeComponentUpsertResponse,
  DependencyDefinition,
  Registry,
} from "@supernova-studio/model";
import { z } from "zod";

//
// Read
//

export const DTOCodeComponentResolvedTypeKind = CodeComponentResolvedTypeKind;

export const DTOCodeComponentResolvedType = CodeComponentResolvedType;

export const DTOCodeComponentParentType = CodeComponentParentType;

export const DTOCodeComponentProperty = CodeComponentProperty;

export const DTOCodeComponent = CodeComponent;

export const DTOCodeComponentResponse = z.object({
  codeComponent: DTOCodeComponent,
});

export const DTOCodeComponentListResponse = z.object({
  codeComponents: DTOCodeComponent.array(),
});

export type DTOCodeComponentResolvedTypeKind = z.infer<typeof DTOCodeComponentResolvedTypeKind>;
export type DTOCodeComponentResolvedType = z.infer<typeof DTOCodeComponentResolvedType>;
export type DTOCodeComponentParentType = z.infer<typeof DTOCodeComponentParentType>;
export type DTOCodeComponentProperty = z.infer<typeof DTOCodeComponentProperty>;
export type DTOCodeComponent = z.infer<typeof DTOCodeComponent>;
export type DTOCodeComponentResponse = z.infer<typeof DTOCodeComponentResponse>;
export type DTOCodeComponentListResponse = z.infer<typeof DTOCodeComponentListResponse>;

//
// Write
//

export const DTOCodeComponentCreateInput = z.object({
  persistentId: z.string(),
  exportName: z.string(),
  componentPath: z.string(),
  description: z.string(),
  properties: z.record(z.string(), DTOCodeComponentProperty),
  tags: z.record(z.string(), z.string()).nullable(),
});

export const DTOCodeComponentsCreateInput = z.object({
  codeComponents: DTOCodeComponentCreateInput.array(),
});

export const DTOCodeComponentUpsertResponse = CodeComponentUpsertResponse;

export type DTOCodeComponentCreateInput = z.infer<typeof DTOCodeComponentCreateInput>;
export type DTOCodeComponentsCreateInput = z.infer<typeof DTOCodeComponentsCreateInput>;
export type DTOCodeComponentUpsertResponse = z.infer<typeof DTOCodeComponentUpsertResponse>;

//
// Analyze
//

export const DTOAnalyzeCodeComponentsInPackage = AnalyzeCodeComponentsInPackage;
export const DTODependencyDefinition = DependencyDefinition;
export const DTORegistry = Registry;

export const DTOAnalyzeCodeComponentsInPackageResponse = z.object({
  ok: z.literal(true),
});

export const DTOAnalyzeCodeComponentsInPackageInput = AnalyzeCodeComponentsInPackage.omit({
  designSystemId: true,
  versionId: true,
  userAccessToken: true,
});

export type DTOAnalyzeCodeComponentsInPackageInput = z.infer<typeof DTOAnalyzeCodeComponentsInPackageInput>;
export type DTOAnalyzeCodeComponentsInPackageResponse = z.infer<typeof DTOAnalyzeCodeComponentsInPackageResponse>;
export type DTOAnalyzeCodeComponentsInPackage = AnalyzeCodeComponentsInPackage;
export type DTODependencyDefinition = DependencyDefinition;
export type DTORegistry = Registry;
